import { render, staticRenderFns } from "./TeflBrochure.vue?vue&type=template&id=19c4954c&comments=true&"
import script from "./TeflBrochure.vue?vue&type=script&lang=js&"
export * from "./TeflBrochure.vue?vue&type=script&lang=js&"
import style0 from "./TeflBrochure.vue?vue&type=style&index=0&id=19c4954c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports